import { Box, LinearProgress } from '@mui/material';
import { useGlobalStore } from '../../application/store/store';

/**
 * Global loading bar component that displays at the top of the page
 * Controlled by global state - can be triggered from anywhere in the app
 *
 * Usage:
 * const { startLoading, stopLoading } = useGlobalStore();
 *
 * startLoading(); // Show loading bar
 * // ... perform async operation
 * stopLoading();  // Hide loading bar
 */
export const LoadingBar = () => {
    const isLoading = useGlobalStore((state) => state.isLoading);

    if (!isLoading) {
        return null;
    }

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
            }}
        >
            <LinearProgress />
        </Box>
    );
};
